import * as React from 'react';
import { clone } from 'ramda';
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';
import Dialog from '../../../../../../../../../../BaseComponents/Dialog/EDDialog';
import EkonomiskAnalysFavoriteToolbar from './Components/EkonomiskAnalysFavoriteToolbar';
import { IFavoriteAnalysDialogButtonProps } from './EkonomiskAnalysFavoriteAnalysDialogButton';
import { ISelection } from '../../../../../Queries/EkonomiskAnalysInitQuery/EkonomiskAnalysInitQuery';
import { SaveFavoriteAnalysFnType } from './Queries/ChangeAnalysFavoriteMutation/ChangeAnalysFavoriteMutation';
import {
  getInitialData,
  getAllChanged,
  startAnalysChanged,
  analysGroupingModeChanged,
  getUtdelningLopnrFavIdKey,
  kombKodbehVisibilityChanged,
  updateStartanalysAtLoginChanged,
} from './Utils/EkonomiskAnalysFavoriteAnalysDialogUtils';
import EkonomiskAnalysFavoriteAnalysList, {
  IAnalysData,
} from './Components/EkonomiskAnalysFavoriteAnalysList';
import Logger from '../../../../../../../../../../Utils/Logger';
import {
  SaveStartAnalysFnType,
  IStartAnalysInfo,
} from './Queries/ChangeStartAnalysMutation/ChangeStartAnalysMutation';
import { IAnalysGroupingModeUserInfo } from '../../../../../Utils/ekonomiskAnalysInitQueryUtils';
import { AnvandarInfo } from '../../../../../Const/AnvandarInfo';
import {
  IKombKodbehVisibility,
  IUpdateKombKodbehVisibiltyFnType,
} from './Components/EkonomiskAnalysFavoriteOptionsMenu';
import { EkonomiskAnalysSaveDBSettingType } from '../../../../../Queries/EkonomiskAnalysSaveDBSettingMutation/EkonomiskAnalysSaveDBSettingMutation';
import shortid from 'shortid';
import { EkonomiskAnalysContextConsumer } from '../../../../Context/EkonomiskAnalysContext';
import { ITreeSection } from '../../../../../../../../../../BaseComponents/TreeSelect/TreeSelectUtils';

interface IProps extends IFavoriteAnalysDialogButtonProps {
  availableAnalyser: ISelection[];
  open: boolean;
  onClose: () => void;
  changeFavorite: SaveFavoriteAnalysFnType;
  changeStartAnalys: SaveStartAnalysFnType;
  startAnalys?: IStartAnalysInfo;
  groupingMode: IAnalysGroupingModeUserInfo;
  kombKodbehVisibility: IKombKodbehVisibility;
  setKombKodbehVisibilityMutation: IUpdateKombKodbehVisibiltyFnType;
  reloadingAnalysList: boolean;
  saveDBSetting: EkonomiskAnalysSaveDBSettingType;
  initialUpdateStartAnalysAtLogin: boolean;
  classes?: any;
}

interface IState {
  favorites: IFavorites;
  originalFavorites: IFavorites;
  categories: string[];
  groupingMode: IAnalysGroupingModeUserInfo;
  startAnalys?: IStartAnalysInfo;
  originalStartAnalys?: IStartAnalysInfo;
  searchValue: string;
  openCodePrivileges: string[];
  kombKodbehVisibility: IKombKodbehVisibility;
  updateStartAnalysAtLogin: boolean;
}

const styles = (theme: Theme) => ({
  dialogPaper: {
    minHeight: '80vh',
    maxHeight: '80vh',
    [theme.breakpoints.down('md')]: {
      minHeight: 'auto',
      maxWidth: 'none',
      maxHeight: '100%',
    },
  },
  dialogHeader: {
    color: theme.customProperties.Fade.LightOnDark.mediumEmphasis,
  },
});

export const FAVORITE_NO_UTDELNING_LOPNR_KEY = 'NO_UTDELNING_LOPNR';
export const USE_NEW_AS_START_ANALYS_ID = 'newAnalysAsStart';

/**
 * favorites[kodbehörighetId][analysId][utdelningLopnr]
 *  */

export interface IFavorites {
  [key: string]: { [key: string]: { [key: string]: IAnalysFavoriteInfo } };
}

export interface IAnalysFavoriteInfo {
  analysId: string;
  kodBehId: string;
  favoritLopnr: number | null;
  utdelatLopnr: number | null;
  category: string;
  isFavorit: boolean;
  grundurvalId: string | undefined;
}

export type EKAnalysGroupingModeType = string;
// const sections: ISection[] = mergeSort(
//   analyserToSections(analyser, sortMode),
//   (a, b) => {
//     if (sortMode === 'kodbeh') {
//       if (a.kombKodbeh && !b.kombKodbeh) {
//         return -1;
//       } else if (b.kombKodbeh && !a.kombKodbeh) {
//         return 1;
//       } else {
//         return stringCompare(a.name, b.name);
//       }
//     }
//     return stringCompare(a.name, b.name);
//   }
// );
export const isAnalysFavoriteSortMode = (
  sortMode: string
): sortMode is EKAnalysGroupingModeType =>
  sortMode === 'kodbeh' || sortMode === 'category';

class EkonomiskAnalysFavoriteAnalysDialog extends React.Component<
  IProps,
  IState
> {
  constructor(props: IProps) {
    super(props);

    const { favorites, categories } = getInitialData(props.availableAnalyser);

    this.state = {
      favorites,
      categories,
      originalFavorites: clone(favorites),
      groupingMode: props.groupingMode,
      startAnalys: props.startAnalys,
      searchValue: '',
      openCodePrivileges: [],
      kombKodbehVisibility: clone(props.kombKodbehVisibility),
      updateStartAnalysAtLogin: this.props.initialUpdateStartAnalysAtLogin,
    };
  }

  componentDidUpdate(prevProps: IProps) {
    const { favorites, categories } = getInitialData(
      this.props.availableAnalyser
    );
    if (
      (this.props.open && prevProps.open !== this.props.open) ||
      this.props.reloadingAnalysList !== prevProps.reloadingAnalysList
    ) {
      this.setState({
        favorites,
        categories,
        originalFavorites: clone(favorites),
        startAnalys: this.props.startAnalys,
        originalStartAnalys: clone(this.props.startAnalys),
        groupingMode: this.props.groupingMode,
        searchValue: '',
        openCodePrivileges: [],
        kombKodbehVisibility: clone(this.props.kombKodbehVisibility),
        updateStartAnalysAtLogin: this.props.initialUpdateStartAnalysAtLogin,
      });
    }
  }

  onCheck = (sections: ITreeSection<IAnalysData>[], isChecked: boolean) => {
    const newFavorites = clone(this.state.favorites);
    sections.forEach(section => {
      if (section.data?.kodBehId) {
        if (this.state.favorites[section.data.kodBehId] == null) {
          Logger.error(
            'EkonomiskAnalysFavoriteAnalysDialog: onCheck: felaktigt kodbehörighets id angett'
          );
          return;
        }

        if (
          this.state.favorites[section.data.kodBehId][section.value] == null
        ) {
          Logger.error(
            'EkonomiskAnalysFavoriteAnalysDialog: onCheck: felaktigt analysid angett'
          );
          return;
        }

        newFavorites[section.data.kodBehId][section.value][
          getUtdelningLopnrFavIdKey(section.data?.utdelatLopnr)
        ].isFavorit = isChecked;
      }
    });
    this.setState({ favorites: newFavorites });
  };

  onCancel = () => {
    this.props.onClose();
  };

  onOk = () => {
    const allChanged = getAllChanged(
      this.state.favorites,
      this.state.originalFavorites
    );
    if (allChanged.length > 0) {
      this.props.changeFavorite(allChanged);
    }
    if (
      startAnalysChanged(this.state.originalStartAnalys, this.state.startAnalys)
    ) {
      this.props.changeStartAnalys(this.state.startAnalys);
    }
    if (
      analysGroupingModeChanged(
        this.props.groupingMode.value,
        this.state.groupingMode.value
      )
    ) {
      this.props.saveDBSetting(
        AnvandarInfo.analysGroupingMode.name,
        this.state.groupingMode
      );
    }
    if (
      kombKodbehVisibilityChanged(
        this.props.kombKodbehVisibility,
        this.state.kombKodbehVisibility
      )
    ) {
      this.props.setKombKodbehVisibilityMutation(
        this.state.kombKodbehVisibility
      );
    }
    if (
      updateStartanalysAtLoginChanged(
        this.props.initialUpdateStartAnalysAtLogin,
        this.state.updateStartAnalysAtLogin
      )
    ) {
      this.props.saveDBSetting(
        AnvandarInfo.ekonomiskAnalysUpdateStartanalysAtLogin.name,
        {
          id: shortid.generate(),
          value: this.state.updateStartAnalysAtLogin ? 'Y' : 'N',
        }
      );
    }

    this.props.onClose();
  };

  onSortModeChange = (newValue: EKAnalysGroupingModeType) => {
    this.setState({
      groupingMode: {
        ...(this.props.groupingMode || { id: '' }),
        value: newValue,
      },
    });
  };

  onKombKodbehVisibilityChange = (newVisibility: IKombKodbehVisibility) => {
    this.setState({ kombKodbehVisibility: newVisibility });
  };

  onFavoritesChanged = (favorites: IFavorites) => {
    this.setState({ favorites: { ...favorites } });
  };

  onStartAnalysChanged = (analys?: IStartAnalysInfo) => {
    this.setState({
      startAnalys: analys,
    });
  };

  onUpdateStartanalysAtLoginChanged = (update: boolean) => {
    this.setState({
      updateStartAnalysAtLogin: update,
    });
  };

  setSearchValue = (value: string) => {
    this.setState({
      searchValue: value,
      openCodePrivileges:
        value === ''
          ? []
          : this.props.availableAnalyser.map(section => section.id),
    });
  };

  filterSearch = () => {
    if (this.state.searchValue.length === 0) {
      return this.props.availableAnalyser;
    }

    const searchValue = this.state.searchValue;

    return this.props.availableAnalyser.filter(section =>
      section.analysList.some(analys =>
        analys.name
          .toLowerCase()
          .trim()
          .includes(searchValue.toLowerCase().trim())
      )
    );
  };

  saveDisabled = () => {
    return (
      !startAnalysChanged(
        this.state.originalStartAnalys,
        this.state.startAnalys
      ) &&
      getAllChanged(this.state.favorites, this.state.originalFavorites)
        .length === 0 &&
      !analysGroupingModeChanged(
        this.props.groupingMode.value,
        this.state.groupingMode.value
      ) &&
      !kombKodbehVisibilityChanged(
        this.props.kombKodbehVisibility,
        this.state.kombKodbehVisibility
      ) &&
      !updateStartanalysAtLoginChanged(
        this.props.initialUpdateStartAnalysAtLogin,
        this.state.updateStartAnalysAtLogin
      )
    );
  };

  render() {
    return (
      <>
        <EkonomiskAnalysContextConsumer>
          {({ hasWholeCodeBook }) => (
            <Dialog
              classes={{
                paper: this.props.classes.dialogPaper,
                dialogHeader: this.props.classes.dialogHeader,
              }}
              onClose={this.onCancel}
              maxWidth="sm"
              fullWidth
              open={this.props.open}
              keepMounted={false}
              title="Välj analyser"
              subtitle="Valda analyser visas i analysväljaren"
              headerTools={
                <EkonomiskAnalysFavoriteToolbar
                  onGroupingModeChange={this.onSortModeChange}
                  key="selectAllCategories"
                  categories={this.state.categories}
                  groupingMode={this.state.groupingMode.value}
                  searchValue={this.state.searchValue}
                  setSearchValue={this.setSearchValue}
                  showUseNewReportAsStart={hasWholeCodeBook}
                  updateStartAnalys={this.onStartAnalysChanged}
                  startAnalys={this.state.startAnalys}
                  availableKodbeh={this.props.availableAnalyser}
                  kombKodbehVisibility={this.state.kombKodbehVisibility}
                  updateKombKodbehVisibility={this.onKombKodbehVisibilityChange}
                  updateStartAnalysAtLogin={this.state.updateStartAnalysAtLogin}
                  setUpdateStartAnalysAtLogin={
                    this.onUpdateStartanalysAtLoginChanged
                  }
                />
              }
              footerActions={[
                { label: 'Avbryt', onClick: this.onCancel },
                {
                  label: 'Använd',
                  onClick: this.onOk,
                  buttonProps: {
                    disabled: this.saveDisabled(),
                  },
                },
              ]}
            >
              <>
                <EkonomiskAnalysFavoriteAnalysList
                  categories={this.state.categories}
                  onAnalysClicked={this.onCheck}
                  analyser={this.filterSearch()}
                  favorites={this.state.favorites}
                  sortMode={this.state.groupingMode.value}
                  updateFavorites={this.onFavoritesChanged}
                  startAnalys={this.state.startAnalys}
                  updateStartAnalys={this.onStartAnalysChanged}
                  searchValue={this.state.searchValue}
                />
              </>
            </Dialog>
          )}
        </EkonomiskAnalysContextConsumer>
      </>
    );
  }
}

export default withStyles(EkonomiskAnalysFavoriteAnalysDialog, styles);
